var KanbanBoardModule = /** @class */ (function () {
    function KanbanBoardModule() {
    }
    return KanbanBoardModule;
}());
export { KanbanBoardModule };
